<!--用户信息块-->
<template>
    <div>
        <div class="user-info">
            <div :class="`photo photo-${size}`">
                <img v-if="!anonymous"
                     :src="`/api/resource/resource/resource/download/${data.photo}?imgStyleName=no_watermark_compress`"
                     alt="">
                <img v-else src="../../../assets/images/common/anonymous.png"
                     alt="">

                <div v-if="!anonymous && data.vip" :class="`vip vip-${size}`">
                    <img src="../../../assets/images/common/vip.svg" alt="">
                    VIP
                </div>
            </div>
            <div class="basic-info">
                <div :class="`nickname nickname-${size}`">
                    <span v-if="anonymous">
                        匿名
                    </span>
                    <span v-else>
                        {{data.nickname}}
                    </span>
                </div>
                <div class="bottom">
                    <div v-if="showTags" class="tags">
                        <div v-if="!anonymous">
                            <div :class="`tag sex sex${data.sex}`">
                                <SexIcon width="10" :type="data.sex"/>
                                {{getAge(data.birthday)}}
                            </div>
                            <div class="tag" style="background: rgba(138,43,226,0.5)">
                                {{data.role}}
                            </div>
                            <div class="tag" style="background: rgba(239,50,121,0.5)">
                            <span v-if="data.sexualOrientation === 'Opposite'">
                                异性恋
                            </span>
                                <span v-else-if="data.sexualOrientation === 'Homosexual'">
                                同性恋
                            </span>
                                <span v-else-if="data.sexualOrientation === 'Diversity'">
                                多性恋
                            </span>
                                <span v-else>
                                其它
                            </span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="tag" style="background: rgba(239,50,121,0.5)">
                                未知
                            </div>
                        </div>
                    </div>
                    <div v-else class="autograph">
                        <span v-if="data.sign">
                            {{data.sign}}
                        </span>
                        <span v-else>
                            该用户暂无签名
                        </span>
                    </div>
                    <div class="desc">
                        {{desc}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SexIcon from "@/components/SexIcon";

    export default {
        components: {SexIcon},
        props: {
            // 用户数据对象
            data: [Object],
            // 描述信息
            desc: [String],
            // 是否匿名
            anonymous: [Boolean],
            // 大小，只支持：[Big、Small]，影响头像大小和昵称大小
            size: {
                default: "Big",
            },
            // 是否显示标签
            showTags: {
                default: true,
            }
        },
        methods: {
            // 根据生日获得年龄
            getAge(date) {
                let birthdays = new Date(date.replace(/-/g, "/"));
                let d = new Date();
                return d.getFullYear() -
                    birthdays.getFullYear() -
                    (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() === birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                        ? 1
                        : 0);
            },
        },
    }
</script>

<style scoped>
    .user-info {
        display: flex;
    }

    .user-info .photo {
        position: relative;
    }

    .user-info .photo-Big {
        height: 3.2rem;
        width: 3.2rem;
    }

    .user-info .photo-Small {
        height: 2.2rem;
        width: 2.2rem;
    }

    .user-info .photo img:first-child {
        width: 100%;
        height: 100%;
        border-radius: 3px;
    }

    .user-info .photo .vip {
        background-color: #EB5280;
        color: #FFF;
        border-radius: 8px;
        text-align: center;
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translate(-50%, 0);
        padding: 0 5px;
        display: flex;
        align-items: center;
        height: 14px;
    }

    .user-info .photo .vip-Big{
        height: 14px;
        font-size: 10px;
    }

    .user-info .photo .vip-Big img{
        width: 10px;
    }

    .user-info .photo .vip-Small{
        height: 12px;
        font-size: 8px;
    }

    .user-info .photo .vip-Small img{
        width: 6px;
    }

    .user-info .photo .vip img {
        vertical-align: middle;
        margin-right: 2px;
    }

    .user-info .basic-info {
        flex: 1;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        width: 0;
    }

    .user-info .basic-info .nickname {
        color: #4e4e4e;
    }

    .user-info .basic-info .nickname-Big {
        font-size: 18px;
    }

    .user-info .basic-info .nickname-Small {
        font-size: 14px;
    }

    .user-info .basic-info .bottom {
        flex: 1;
        display: flex;
        width: 100%;
    }

    .user-info .basic-info .bottom div:first-child {
        flex: 1;
    }

    .user-info .basic-info .bottom .tags .tag {
        display: inline-block;
        line-height: 1.3em;
        padding: 0 0.5em;
        font-size: 14px;
        text-align: center;
        border-radius: 3px;
        color: #fff;
    }

    .user-info .basic-info .bottom .tags .tag:not(:last-child) {
        margin-right: 5px;
    }

    .user-info .basic-info .bottom .tags .sexM {
        background-color: rgba(32, 118, 255, 0.5);
    }

    .user-info .basic-info .bottom .tags .sexF {
        background-color: rgba(234, 95, 154, 0.5);
    }

    .user-info .basic-info .bottom .tags .sexCDTS {
        background-color: rgba(187, 58, 246, 0.5);
    }

    .user-info .basic-info .bottom .desc {
        color: #676767;
        font-size: 12px;
    }

    .user-info .basic-info .bottom .autograph {
        color: #676767;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>